var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wi100 hi100"},[_c('iframe',{staticClass:"frame-wrap",attrs:{"src":"http://www.zykjfw.cn/index"}})])
}]

export { render, staticRenderFns }